import axios from 'axios'

export default {
    async create (project, data) {
      try {
        const response = await axios.post(`/projects/${project}/publications`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async update (publication, data) {
      try {
        const response = await axios.patch(`/publications/${publication}`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async saveConfig (publication, data) {
      try {
        const response = await axios.patch(`/publications/${publication}/save-config`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },

    async publicPreviewLinkUpdate (link, data) {
      try {
        const response = await axios.post(`/links/${link}/update`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    
    async updateProjectConfiguration (project, configuration) {
      try {
        const response = await axios.patch(`/projects/${project}`, { configuration })
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async destroy (publication) {
      try {
        const response = await axios.delete(`/publications/${publication}`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async saveMenu (publication, data) {
      try {
        const response = await axios.post(`/publications/${publication}/save-menu`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async publish (publication, data) {
      // { all: true } OR  { locale: locale } OR null (combined)
      try {
        const response = await axios.post(`/publications/${publication}/publish`, data)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async bulkExport (project, items = []) {
      try {
        const response = await axios.post(`/projects/${project}/publications/scripts`, { items })
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async bulkPackage (project) {
      try {
        const response = await axios.post(`/projects/${project}/publications/packages`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async bulkAssetExport (project, items = []) {
      try {
        const response = await axios.get(`/projects/${project}/asset-csv`, { items })
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async selectedBulkExport (project, items = []) {
      try {
        const response = await axios.post(`/projects/${project}/publications/scripts`, { items })
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async createPublicLink (publication) {
      try {
        const response = await axios.post(`/publications/${publication}/links/create`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async resetPublicLink (link) {
      try {
        const response = await axios.post(`/links/${link}/reset`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async lockPublicLink (link) {
      try {
        const response = await axios.post(`/links/${link}/lock`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async deletePublicLink (link) {
      try {
        const response = await axios.post(`/links/${link}/remove`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async deleteLocalizedZip (publicationZip) {
      try {
        const response = await axios.delete(`/package/${publicationZip}/delete`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
    async syncTheme (project) {
      try {
        const response = await axios.post(`/projects/${project}/sync-theme`)
        return _.get(response, 'data.data')
      } catch (err) {
        console.error(err)
        return _.get(err, 'response.data', false)
      }
    },
}